'use strict';

module.exports = {
    LANG: 'uk-ua',
    SIGN: 'Увійти',
    REGISTER: 'ЗАРЕЄСТРУВАТИСЯ',
    QUICK_ACCESS: 'Швидкий доступ через',
    SIGN_JOIN: 'Увійдіть або зареєструйтеся безкоштовно!',
    NOT_MEMBER: 'Не учасник?',
    ALREADY_MEMBER: 'Учасник AliExpress/Alibaba?',
    SHOW_ALL: 'Показати все',
    HIDE: 'Приховати'
};